<template>
  <section class="all-templates-view heightClass overflow-y-auto overflow-x-hidden !rounded-xl">
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
    >
      <h3
        class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
      >
        {{ 'Kodefast Market Place' }}
      </h3>
      <div class="flex items-center justify-start md:!justify-end !gap-0 md:!gap-3 flex-wrap">
        <template v-if="!getIsMobile">
          <el-input
            class="search ApplyFont"
            placeholder="Search"
            v-model="search_string"
            prefix-icon="el-icon-search"
            size="mini"
            clearable
            :style="getIsMobile ? 'width:130px' : 'width:170px;'"
          ></el-input>

          <el-select
            style="width: 170px"
            size="mini"
            class="ApplyFont"
            placeholder="Industry Type"
            v-model="selectedIndustries"
            clearable
            multiple
            collapse-tags
            filterable
            remote
          >
            <el-option
              v-for="item in allIndustries"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select
            style="width: 170px"
            size="mini"
            class="ApplyFont"
            placeholder="Select Category"
            v-model="selectedCategories"
            clearable
            multiple
            collapse-tags
            filterable
            remote
          >
            <el-option
              v-for="item in allCategories"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-button
            style="background: var(--brand-500) !important"
            class="!py-1.5 !px-3 !rounded-sm hover:!bg-brand-500 !border-brand-500"
            @click="handleDialog(true)"
            size="mini"
          >
            <span class="flex items-center !gap-1.5">
              <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
              <span class="text-xs font-light text-white">Create Your Own Application</span>
            </span>
          </el-button>
          <el-dropdown style="border: none">
            <el-button
              size="mini"
              type="Secondary"
              class="el-dropdown-link !py-1 !px-1.5 !rounded-sm !border border-solid border-black/40"
            >
              <img
                src="@/assets/img/icons/new/list-icon.svg"
                alt=""
                class="!size-5 hover:fill-brand-500"
              />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/apps/installed">
                <a style="border: none">
                  <el-dropdown-item
                    v-if="getCompanyDetails && getCompanyDetails._id != approvalsCompanyId"
                    icon="el-icon-download"
                    command="view"
                  >
                    Installed Apps
                  </el-dropdown-item>
                </a>
              </router-link>

              <a
                style="border: none"
                @click="openApprovals"
                v-if="getCompanyDetails && getCompanyDetails._id == approvalsCompanyId"
              >
                <el-dropdown-item icon="el-icon-top-right" command="view">
                  Approvals
                </el-dropdown-item>
              </a>

              <a style="border: none" @click="createApp">
                <el-dropdown-item icon="el-icon-folder" command="view">
                  My Solutions
                </el-dropdown-item>
              </a>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <el-row gutter="10" style="display: flex">
            <el-col :span="24">
              <el-select
                style="width: 100%"
                size="mini"
                class="mr-1"
                placeholder="Industrial Type"
                v-model="selectedIndustries"
                clearable
                multiple
                collapse-tags
                filterable
                remote
              >
                <el-option
                  v-for="item in allIndustries"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="24">
              <el-select
                style="width: 100%"
                size="mini"
                class="mr-1"
                placeholder="Select Category"
                v-model="selectedCategories"
                clearable
                multiple
                collapse-tags
                filterable
                remote
              >
                <el-option
                  v-for="item in allCategories"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <div style="display: flex; margin-top: 10px; gap: 8px; justify-content: flex-start">
            <el-input
              class="search"
              placeholder="Search"
              v-model="search_string"
              prefix-icon="el-icon-search"
              size="mini"
              clearable
              :style="getIsMobile ? 'width:130px' : 'width:170px;'"
            ></el-input>
            <el-button
              style="background: var(--brand-500) !important"
              class="!py-1 !px-3 !rounded-sm hover:!bg-brand-500 !border-brand-500"
              type="primary"
              @click="handleDialog(true)"
              size="mini"
            >
              <span class="flex items-center !gap-1.5">
                <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
                <span class="text-xs font-light text-white">Create Application</span>
              </span>
            </el-button>
            <el-dropdown style="border: none">
              <el-button
                size="mini"
                class="el-dropdown-link !py-0.5 !px-1.5 !rounded-sm !border border-solid border-black/40 hover:bg-black/10"
              >
                <img src="@/assets/img/icons/new/list-icon.svg" alt="" class="!size-5" />
              </el-button>

              <el-dropdown-menu slot="dropdown">
                <router-link to="/apps/installed">
                  <a style="border: none">
                    <el-dropdown-item
                      v-if="getCompanyDetails && getCompanyDetails._id != approvalsCompanyId"
                      icon="el-icon-download"
                      command="view"
                    >
                      Installed Apps
                    </el-dropdown-item>
                  </a>
                </router-link>

                <a
                  style="border: none"
                  @click="openApprovals"
                  v-if="getCompanyDetails && getCompanyDetails._id == approvalsCompanyId"
                >
                  <el-dropdown-item icon="el-icon-top-right" command="view">
                    Approvals
                  </el-dropdown-item>
                </a>

                <a style="border: none" @click="createApp">
                  <el-dropdown-item icon="el-icon-folder" command="view">
                    My Solutions
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </div>
    </div>
    <div class="!pt-3 !px-3" v-loading="loading">
      <div
        class="grid grid-cols-1 sm:!grid-cols-2 lg:!grid-cols-3 2xl:!grid-cols-4 !gap-3"
        v-if="allApps.length"
      >
        <div
          class="!border !border-page-border !bg-card-color !rounded-[8px] hover:shadow-sm hover:translate-y-[-5px] transition-all duration-300 ease-in-out"
          v-for="app in allApps"
          :key="app._id"
        >
          <div
            class="flex flex-col items-center justify-center bg-black-100 !p-3 !rounded-[8px_8px_0_0] !gap-2"
          >
            <img
              v-if="app.icon"
              :src="require('@/assets/img/icons/menu/' + app.icon)"
              class="card-img-top app-icon mx-auto"
            />
            <img
              v-else-if="
                app.version && app.version[0] && app.version[0].logo && app.version[0].logo.length
              "
              :src="`${S3_BUCKET_URL}/${app.version[0].logo[0]}`"
              class="card-img-top app-icon mx-auto"
            />
            <img
              v-else
              src="require('@/assets/img/icons/menu/company-document-2.svg')"
              alt="menu"
              class="card-img-top app-icon mx-auto"
            />
            <h5 class="text-black-950 text-smd 2xl:!text-base !font-normal !m-0">
              {{ app.name }}
            </h5>
          </div>
          <div class="!p-3">
            <p class="flex items-center justify-between !mb-2">
              <span class="text-black-500 text-xs 2xl:text-sm !font-light">Developer</span>
              <span class="text-black-950 text-xs 2xl:text-sm !font-normal">
                {{ app.developed_by.name }}
              </span>
            </p>
            <p class="flex items-center justify-between">
              <span class="text-black-500 text-xs 2xl:text-sm !font-light">Downloads</span>
              <span
                class="!bg-[#2F80ED1F] !text-[#0D52AF] !px-2 !py-1 !rounded-md text-xs 2xl:text-sm !font-normal flex items-center !gap-1"
              >
                <img src="@/assets/img/icons/new/download-blue-icon.svg" alt="" class="!size-4" />
                {{ downloadsCount[app._id] }}
              </span>
            </p>
            <p
              class="card-description mt-3 !mb-0 flex-grow-1 text-truncate text-black-500 text-xs 2xl:text-sm !font-light"
            >
              {{
                app.single_line_description ||
                'Employee management involves the activities and performance of employees within an organization.'
              }}
            </p>
          </div>
          <div
            class="grid grid-cols-2 !gap-3 !px-3 2xl:!gap-6 2xl:!px-6 !py-3 justify-between !border-t !border-page-border"
          >
            <button
              class="w-full !border !border-[#828282B2] hover:bg-[#82828225] !rounded-md !text-[#828282] box-border !py-2 !px-3 text-xs 2xl:text-smd !font-normal"
              @click="appInfo(app)"
            >
              <span class="flex items-center justify-center !gap-1">
                <img src="@/assets/img/icons/new/info-gray-icon.svg" alt="" class="!size-4" />
                More Info
              </span>
            </button>
            <button
              class="w-full !border !border-brand-500 hover:bg-brand-100 !rounded-md !text-brand-500 box-border !px-3 !py-2 text-xs 2xl:text-smd !font-normal"
              v-if="
                checkPermissionByPermissionName('cloneApp') &&
                !alreadyInstalledAppsIds.includes(app._id)
              "
              @click="install(app)"
              :disabled="getCompanyDetails && getCompanyDetails._id == approvalsCompanyId"
            >
              <span class="flex items-center justify-center !gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="currentColor"
                >
                  <path
                    d="M14.0625 8.99951V12.9995C14.0625 13.1321 14.0098 13.2593 13.9161 13.3531C13.8223 13.4468 13.6951 13.4995 13.5625 13.4995H2.5625C2.42989 13.4995 2.30271 13.4468 2.20895 13.3531C2.11518 13.2593 2.0625 13.1321 2.0625 12.9995V8.99951C2.0625 8.8669 2.11518 8.73973 2.20895 8.64596C2.30271 8.55219 2.42989 8.49951 2.5625 8.49951C2.69511 8.49951 2.82229 8.55219 2.91605 8.64596C3.00982 8.73973 3.0625 8.8669 3.0625 8.99951V12.4995H13.0625V8.99951C13.0625 8.8669 13.1152 8.73973 13.2089 8.64596C13.3027 8.55219 13.4299 8.49951 13.5625 8.49951C13.6951 8.49951 13.8223 8.55219 13.9161 8.64596C14.0098 8.73973 14.0625 8.8669 14.0625 8.99951ZM7.70875 9.35326C7.75519 9.39975 7.81033 9.43663 7.87103 9.46179C7.93173 9.48695 7.99679 9.4999 8.0625 9.4999C8.12821 9.4999 8.19327 9.48695 8.25397 9.46179C8.31467 9.43663 8.36981 9.39975 8.41625 9.35326L10.9163 6.85326C10.9627 6.80681 10.9996 6.75166 11.0247 6.69096C11.0498 6.63026 11.0628 6.56521 11.0628 6.49951C11.0628 6.43381 11.0498 6.36876 11.0247 6.30806C10.9996 6.24737 10.9627 6.19222 10.9163 6.14576C10.8698 6.09931 10.8146 6.06246 10.7539 6.03731C10.6933 6.01217 10.6282 5.99923 10.5625 5.99923C10.4968 5.99923 10.4317 6.01217 10.3711 6.03731C10.3104 6.06246 10.2552 6.09931 10.2087 6.14576L8.5625 7.79264V1.99951C8.5625 1.8669 8.50982 1.73973 8.41605 1.64596C8.32229 1.55219 8.19511 1.49951 8.0625 1.49951C7.92989 1.49951 7.80271 1.55219 7.70895 1.64596C7.61518 1.73973 7.5625 1.8669 7.5625 1.99951V7.79264L5.91625 6.14576C5.82243 6.05194 5.69518 5.99923 5.5625 5.99923C5.42982 5.99923 5.30257 6.05194 5.20875 6.14576C5.11493 6.23958 5.06222 6.36683 5.06222 6.49951C5.06222 6.63219 5.11493 6.75944 5.20875 6.85326L7.70875 9.35326Z"
                  />
                </svg>
                Install
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col text-center">
          <div class="alert alert-warning">No application data.</div>
        </div>
      </div>
      <div
        v-if="total"
        class="!px-3 sticky bottom-0 bg-container-background !py-2 z-10 flex items-center justify-center flex-wrap"
      >
        <el-pagination
          :v-model:current-page="currentPage"
          :v-model:page-size="pageSize"
          class="custom-pagination flex itemx-center justify-center !gap-2 flex-wrap"
          :page-sizes="[8, 16, 24, 32, 100]"
          layout="prev, pager, next, jumper, sizes, total"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <dialog-component
      :title="popupData.name"
      :visible="dialogVisible"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @before-close="dialogVisible = false"
      class="installApplicationPopUp"
    >
      <div slot="title" class="dialog-header">
        <p style="color: #fff; font-size: 16px">{{ popupData.name }}</p>
      </div>
      <div class="!pt-2 !min-w-96">
        <div class="!mb-4">
          <div class="text-black-500 !text-sm !font-normal !mb-1">
            App Name
            <span style="color: red">*</span>
          </div>
          <el-input placeholder="Enter App Name" v-model="popupData.newName"></el-input>
        </div>
        <div class="!mb-1">
          <div class="text-black-500 !text-sm !font-normal !mb-1">Description</div>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="Please Input"
            v-model="popupData.newDescription"
          ></el-input>
        </div>
        <el-checkbox style="margin-top: 5px" v-model="popupData.IsInstallAsWorkspace">
          Install App As a New Workspace
        </el-checkbox>
      </div>
      <span slot="footer">
        <div class="buttons">
          <el-button
            @click="dialogVisible = false"
            class="bg-transparent text-black-700 !px-4 !py-1 !rounded-md !text-xs 2xl:!text-sm !border !border-black/10 !mr-1 hover:!text-brand-500 hover:!border-brand-500"
          >
            Cancel
          </el-button>
          <el-button
            style="background: var(--brand-500) !important"
            class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:!text-sm !border-none"
            type="button"
            @click="installApplication"
          >
            Install
          </el-button>
        </div>
      </span>
    </dialog-component>
    <dialog-component
      :title="popupData.name"
      :visible="moreInfoDialogVisible"
      width="50%"
      @before-close="ClosemoreInfoDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="installApplicationPopUp"
    >
      <div slot="title" class="dialog-header">
        <p style="color: #fff; font-size: 16px">{{ popupData.name }}</p>
      </div>
      <div class="dialog-body">
        <el-row>
          <el-col :span="20">
            <div>
              <div class="slideshow">
                <el-carousel :interval="3000" indicator-position="outside">
                  <el-carousel-item
                    v-for="(item, index) in popupData.version &&
                    popupData.version[0] &&
                    popupData.version[0].images"
                    :key="index"
                  >
                    <img :src="`${S3_BUCKET_URL}/${item}`" alt="Slideshow Image" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="info">
                <div class="sidemenu">
                  <p>{{ popupData.description }}</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="margin-top: 30px">
              <ul>
                <li
                  v-if="popupData.version && popupData.version[0] && popupData.version[0].entities"
                >
                  <b>Entities</b>
                  : {{ popupData.version[0].entities.length }}
                </li>
                <li
                  v-if="
                    popupData.version &&
                    popupData.version[0] &&
                    popupData.version[0].menuManagementWithRoles
                  "
                >
                  <b>Roles</b>
                  :
                  {{ popupData.version[0].menuManagementWithRoles.length }}
                </li>
                <li
                  v-if="popupData.version && popupData.version[0] && popupData.version[0].version"
                >
                  <b>version</b>
                  : {{ popupData.version[0].version }}
                </li>
                <li></li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </dialog-component>
    <el-dialog
      :visible.sync="appLoadingDialogVisible"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
    >
      <div class="text-center">
        <img src="@/assets/img/importDataLoading.gif" class="import-loading-gif" />
        <p>Please wait</p>
        <h1>Your Application installation is in progress...</h1>
      </div>
    </el-dialog>
    <dialog-component
      title="Create Application Using AI or Excel"
      :visible="createNewAppDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      v-loading="dialogLoading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-text="Checking company name"
      @before-close="handleDialog(false)"
    >
      <div class="Build-New-Solution !pt-2">
        <el-form>
          <el-form-item class="!mb-4">
            <label class="text-black-500 text-xs 2xl:!text-sm font-normal !mb-1">
              Workspace Settings
            </label>
            <div>
              <el-radio-group v-model="workspaceSetting">
                <el-radio label="Current Workspace"></el-radio>
                <el-radio label="Install At New Workspace"></el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item class="!mb-4" v-if="workspaceSetting == 'Install At New Workspace'">
            <label class="text-black-500 text-xs 2xl:!text-sm font-normal !mb-1">
              Workspace Name
            </label>
            <el-input
              placeholder="Enter Workspace Name"
              v-model="newWorkspaceName"
              clearable
              id="workspaceTitle"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleDialog(false)"
          size="small"
          class="bg-transparent text-black-700 !px-4 !py-1 !rounded-md !text-xs 2xl:!text-sm !border !border-black/10 !mr-1 hover:!text-brand-500 hover:!border-brand-500"
        >
          Cancel
        </el-button>
        <el-button
          style="background: var(--brand-500) !important"
          class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:!text-sm !border-none"
          type="button"
          :disabled="handleNextDisable()"
          @click="createNewApplication"
          size="small"
        >
          Next
        </el-button>
      </span>
    </dialog-component>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import authHelper from '@/mixins/authHelper';
  import config from '../../config/app';
  export default {
    name: 'Applications-List',
    data() {
      return {
        S3_BUCKET_URL: config.S3_BUCKET_URL,
        averageRating: 3.5, // The fixed average rating value
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        dialogVisible: false,
        moreInfoDialogVisible: false,
        popupData: {
          checked: false,
          IsInstallAsWorkspace: true,
          newName: '',
          newDescription: '',
          images: [],
        },
        order_by: 'title',
        order_type: 'asc',
        search_string: '',
        configureLoading: false,
        total: 0,
        activeStep: 0,
        currentPage: 1,
        pageSize: 0,
        pagination: [8, 16, 24, 32, 40],
        page: 1,
        newEntityModal: false,
        entityName: '',
        description: '',
        isAccount: false,
        entity_type: 'GENERAL',
        modalLoading: false,
        allEntities: [],
        showAddGroupDialog: false,
        groupName: '',
        loadingSaveGroup: false,
        entityGroupsData: [],
        allApps: [],
        loading: true,
        allWorkspaces: [],
        allIndustries: [],
        selectedIndustryTypeName: '',
        selectedCategories: [],
        selectedIndustries: [],
        allCategories: [],
        appLoadingDialogVisible: false,
        mappingStatusDialogVisible: false,
        addIndustryDialog: false,
        currentWorkspace: {},
        userWorkspaceList: [],
        downloadsCount: {},
        alreadyInstalledAppsIds: [],
        approvalsCompanyId: '',
        createNewAppDialog: false,
        newWorkspaceName: '',
        workspaceSetting: 'Install At New Workspace',
        dialogLoading: false,
      };
    },
    mixins: [PermissionsHelper, NavigationHelper, authHelper],
    computed: {
      getIsMobile() {
        return window.innerWidth <= 520;
      },
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getUserType',
        'getWorkspaceList',
        'getAuthenticationStatus',
      ]),
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('company', [
        'getCompanyDetails',
        'getUpdateCompany',
        'getCompanyLogo',
        'getSingleCompanyLogo',
        'getCompanyExistsStatus',
      ]),
      ...mapGetters('apps', [
        'getAllApps',
        'getAppErrors',
        'getInstallationStatus',
        'getAllCategories',
        'getAppInstallationErrors',
        'getInstalledApplications',
      ]),
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 20, 50],
        };
      },
    },
    async mounted() {
      if (
        this.getCompanyDetails &&
        (this.getCompanyDetails.is_admin_clone || this.getCompanyDetails.is_cloned)
      ) {
        this.$notify.error({
          title: 'Error',
          message: "You can't Access market place in an application",
        });
        this.$router.push({ path: '/dashboard' });
      } else {
        this.allWorkspaces = this.getWorkspaceList.map((workspace) => {
          let workspaceName = workspace.company_id.name;
          return workspaceName;
        });
        this.approvalsCompanyId = process.env.VUE_APP_APPROVALS_COMPANY_ID;
        await Promise.all([
          this.fetchAllApps(),
          this.fetchAllCategories(),
          this.fetchInstalledApplications(),
        ]);
      }
    },
    methods: {
      ClosemoreInfoDialogVisible() {
        this.moreInfoDialogVisible = false;
      },
      async handleSizeChange(val) {
        this.loading = true;
        this.pageSize = parseInt(val);
      },
      async handleCurrentChange(val) {
        this.loading = true;
        this.currentPage = parseInt(val);
      },

      async installApplication() {
        if (this.popupData.newName && this.popupData.description) {
          this.appLoadingDialogVisible = true;
          this.popupData.newName = this.popupData.newName.trim();

          // Check if the trimmed newName is empty or contains only spaces
          if (!this.popupData.newName) {
            this.appLoadingDialogVisible = false;
            return this.$notify.error({
              title: 'Error',
              message: 'Please enter a valid company name',
            });
          }
          await this.$store.dispatch('apps/installApplication', this.popupData);
          if (this.getInstallationStatus) {
            this.dialogVisible = false;
            this.appLoadingDialogVisible = false;
            this.$message.success(this.popupData.name + '  is installed');
            if (this.popupData && this.popupData.IsInstallAsWorkspace) {
              await this.changeWorkspace(this.getInstallationStatus.data.newCompanyId);
            }
          } else {
            this.appLoadingDialogVisible = false;
            return this.$notify.error({
              title: 'Error',
              message: this.getAppInstallationErrors || 'Error installing app',
            });
          }
        } else {
          this.$message('Please provide all the required Information');
        }
      },
      async getCompanyUserType(activeRole) {
        try {
          await this.$store.dispatch('auth/getUserTypeById', activeRole);
        } catch (err) {
          console.log('getCompanyUserType', err);
          this.$notify.error({
            title: 'Error',
            message: err,
          });
        }
      },
      async install(app) {
        this.popupData = { ...this.popupData, ...app };
        this.dialogVisible = true;
      },
      async appInfo(app) {
        this.popupData = { ...this.popupData, ...app };
        this.moreInfoDialogVisible = true;
      },
      async fetchAllApps() {
        this.loading = true;
        try {
          let params = {
            limit: this.pageSize > 0 ? this.pageSize : 8,
            page: this.currentPage,
            isOwner: false,
            isPublishedApplications: true,
          };

          if (this.search_string) {
            params.search_string = this.search_string;
          }
          if (this.order_type) {
            params.order_type = this.order_type;
          }
          if (this.selectedCategories) {
            params.selectedCategories = this.selectedCategories;
          }
          if (this.selectedIndustries) {
            params.selectedIndustries = this.selectedIndustries;
          }
          await this.$store.dispatch('apps/fetchAllApplications', params);
          if (this.getAllApps) {
            this.allApps = [...this.getAllApps.data];
            this.total = this.getAllApps && this.getAllApps.total ? this.getAllApps.total : 0;
            this.downloadsCount =
              this.getAllApps && this.getAllApps.downloads_count
                ? this.getAllApps.downloads_count
                : {};
            this.currentPage = parseInt(this.getAllApps.page) || 1;

            this.loading = false;
          } else {
            this.loading = false;
          }
        } catch (err) {
          console.log('fetchAllApps', err);
        }
      },
      async fetchAllCategories() {
        try {
          await this.$store.dispatch('apps/fetchAllCategories');
          if (this.getAllCategories) {
            this.allIndustries = [...this.getAllCategories.data];
            this.allCategories = [
              ...new Set(this.allIndustries.map((item) => item.categories).flat()),
            ];
          }
        } catch (err) {
          console.log('fetchAllCategories', err);
        }
      },
      beforeDestroy() {
        this.$store.commit(
          'navigationOpen/setCurrentMenu',
          {},
          {
            root: true,
          }
        );
      },
      createApp() {
        this.$router.push({ path: '/apps/published' });
      },
      handleDialog(value) {
        this.createNewAppDialog = value;
      },
      handleNextDisable() {
        if (this.workspaceSetting == 'Install At New Workspace' && !this.newWorkspaceName.trim()) {
          return true;
        }
        return false;
      },
      createNewApplication() {
        if (this.workspaceSetting === 'Current Workspace') {
          this.$router.push({ path: '/apps/create-from-excel' });
        } else {
          this.addWorkspace();
        }
      },
      async addWorkspace() {
        let params = { workspace: this.newWorkspaceName.trim() };
        this.dialogLoading = true;
        await this.$store.dispatch('company/fetchCompanyNameStatus', params);
        if (this.getCompanyExistsStatus) {
          this.dialogLoading = false;
          if (!this.getCompanyExistsStatus.success) {
            return this.$notify.error({
              title: 'Error',
              message: this.getCompanyExistsStatus.message,
            });
          }
        }
        this.dialogLoading = false;
        this.$router.push({ path: '/apps/create-from-excel', query: params });
      },
      openApprovals() {
        if (!this.checkPermissionByPermissionName('addApp')) {
          this.$notify.error({
            title: 'Error',
            message: "You don't have permission to access this",
          });
        } else {
          this.$router.push({ path: '/apps/approvals' });
        }
      },
      async fetchInstalledApplications() {
        try {
          this.configureLoading = true;
          let params = {
            get_all: true,
            isOwner: true,
            installedApps: true,
          };
          if (this.search_string) {
            params.search_string = this.search_string;
          }

          if (this.order_type) {
            params.order_type = this.order_type;
          }

          await this.$store.dispatch('apps/fetchAllInstalledApplications', params);
          if (this.getInstalledApplications) {
            this.alreadyInstalledAppsIds = this.getInstalledApplications.data.map(
              (app) => app.app_id
            );
            this.total =
              this.getInstalledApplications && this.getInstalledApplications.total
                ? this.getInstalledApplications.total
                : 0;
            this.currentPage = parseInt(this.getInstalledApplications.page) || 1;
            this.configureLoading = false;
          } else {
            this.configureLoading = false;
          }
        } catch (err) {
          console.log('fetchInstalledApplications', err);
        }
      },
    },
    watch: {
      currentPage: async function () {
        this.fetchAllApps();
      },
      pageSize: async function () {
        this.fetchAllApps();
      },
      search_string: async function () {
        this.fetchAllApps();
      },
      selectedIndustries: async function () {
        this.fetchAllApps();
      },
      selectedCategories: async function () {
        this.fetchAllApps();
      },
    },
  };
</script>
<style scoped lang="scss">
  .ApplyFont ::v-deep .el-input__inner {
    font-family: var(--font-family);
  }
  .import-loading-gif {
    height: 30vh;
    width: 15vw;
  }
  .card-content {
    display: flex;
    justify-content: space-between;
  }

  .left-content {
    display: flex;
    align-items: center;
  }

  .right-content {
    margin-left: auto;
  }

  .el-card {
    height: 180px;
    font-size: 12px;
  }

  .el-card h5 {
    font-size: 14px;
  }

  .card-button {
    border-radius: 5px;
  }

  .custom-pagination {
    text-align: center;
  }
  .card-container {
    display: flex;
    flex-wrap: wrap;
  }

  .installApplicationPopUp .dialog-body {
    margin: 20px;
  }

  .installApplicationPopUp {
    .slideshow {
      flex-basis: 100%;
      height: 100%;
      margin: 3%;
      border: 1px solid #f7f0f0;
      border-radius: 5px;
      padding: 1%;
    }
    .el-carousel__indicators.is-arrow .el-carousel__indicator.is-active {
      background-color: #000; /* Set the background color to black */
    }
    .slideshow img {
      width: 100%;
      height: 95%;
      object-fit: cover;
    }

    .info {
      flex-basis: 50%;
      height: 30%;
      margin: 2%;
    }

    .sidemenu {
      height: 108px;
      overflow-y: auto;
      overflow-x: auto;
      margin-right: 5px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .dialog-body {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .division-one {
      height: auto;
      overflow: auto;
      width: 70%;
    }

    .division-two {
      padding: 20px;
      border: 1px solid #ddd;
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }

    .el-icon-arrow-down {
      font-size: 10px;
    }

    .demonstration {
      display: block;
      color: #8492a6;
      font-size: 14px;
      margin-bottom: 20px;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
    }
  }

  .float-right {
    float: right;
  }

  .imgSize {
    height: 4.5em;
    width: 4.5em;
    margin-right: 5px;
  }

  .text-justify {
    text-align: justify;
    word-break: break-all;
  }

  .text-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .doc-title {
    cursor: pointer;
    font-size: 14px;
    font-family: var(--font-family);
    font-weight: 300;
    line-height: 14px;
    text-align: left;
    color: #6c757d !important;
  }

  .activestatus {
    font-size: 14px;
    color: #6c757d !important;
  }

  .circle {
    position: relative;
    padding-left: 20px;
    text-transform: capitalize;
    font-size: 14px;

    &::after {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      height: 10px;
      width: 10px;
      display: inline-block;
      border-radius: 50%;
    }

    &.active::after {
      background: #08ad36;
    }

    &.inactive::after {
      background: #f562b3;
    }

    &.deleted::after {
      background: #8b1702;
    }

    &.archived::after {
      background: #404040;
    }

    &.disable::after {
      background: #c4c4c4;
    }

    &.viewed::after {
      background: #2f80ed;
    }
  }
</style>
<style lang="scss">
  .top-buttons-wrapper {
    @media (max-width: 991.98px) {
      display: flex;
      margin-top: 20px;
    }
    @media (max-width: 520px) {
      display: block;
    }
  }

  .new-entity-information {
    .el-dialog {
      width: 800px;
      padding-bottom: 15px;

      @media (max-width: 800px) {
        width: 700px;
        margin-top: 40px !important;
      }

      @media (max-width: 700px) {
        width: 600px;
        margin-top: 40px !important;
      }

      @media (max-width: 600px) {
        width: 500px;
        margin-top: 40px !important;
      }

      @media (max-width: 500px) {
        width: 400px;
        margin-top: 40px !important;
      }

      @media (max-width: 400px) {
        width: 300px;
        margin-top: 40px !important;
      }

      .entity-type-radio {
        @media (max-width: 400px) {
          & > label {
            & > span {
              padding-left: 5px !important;
              padding-right: 5px !important;
            }
          }
        }
      }
    }
  }
</style>
<style scoped>
  .solution {
    position: relative;
    bottom: 5px;
  }
</style>
<style scoped lang="scss">
  .app-card {
    transition:
      transform 0.3s ease-in-out,
      box-shadow 0.3s ease-in-out;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .app-card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 20px #00000033;
  }

  .app-icon {
    width: 70px;
    height: 70px;
    object-fit: contain;
    border-radius: 50%;
    border: 1px solid #00000008;
    @media (max-width: 576px) {
      width: 50px;
      height: 50px;
    }
  }

  .card-description {
    max-height: 50px;
    overflow: hidden;
  }

  @media (max-width: 576px) {
    .app-card {
      text-align: center;
    }
    .card-description {
      font-size: 0.85rem;
    }
    .btn {
      font-size: 0.8rem;
    }
  }

  p {
    margin-bottom: 5px !important;
  }
</style>
